import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import FormWrapper from '../../../../../library/form/components/FormWrapper';
import ProdIOListQtyCell, { ProdIOListUnitCell } from './ProdIOListQtyCell';

const ProdIOTSumMatRow = (props) => {
    const { formObject, viewData, rowKey } = props;

    const rowCss = formObject.getValueFromKey(viewData, "dataList.cssClass", "");

        return (
            <ul className={`uiDPEditLine uiTableRowLevel1 ${rowCss}`}>
                <li className="uiColumnLeft uiColumn130">
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "id" }} />
                </li>
                <li className="uiColumnLeft uiColumn350">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ paramName: "actualItem", actionId: "show" }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
                <ProdIOListUnitCell formObject={formObject} rowKey={rowKey} param1="unit1" param2="unit2" />
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                    action={{ paramName: "variation1Name" }} >
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation1" }} />
                </FormWrapper>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig"
                    action={{ paramName: "variation2Name" }} >
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation2" }} />
                </FormWrapper>
                <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyIssued1" param2="qtyIssued2" format="a" />
                <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyReturned1" param2="qtyReturned2" format="a" />
                <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyConsumed1" param2="qtyConsumed2" format="a" />
                <ProdIOListQtyCell formObject={formObject} rowKey={rowKey} param1="qtyWasted1" param2="qtyWasted2" format="a" />
                <li className="uiColumnRight uiColumn70">
                    <FormROValue format="a" formObject={formObject} rowKey={rowKey} action={{ paramName: "unitCost" }} />
                </li>
                <li className="uiColumnLeft uiColumn100">
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "remark" }} />
                </li>
                <li className="uiColumnCenter uiColumn90 uiSpacer5">
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "status" }} />
                </li>
            </ul>
        )
}

export default ProdIOTSumMatRow
